import { TOKEN_EXPIRE_KEY } from "./constant";

export default function resetExpire() {
  localStorage.setItem(TOKEN_EXPIRE_KEY, new Date().toISOString()); // refresh expire
}
